import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import api from "@/lib/api";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import ResetPassword from "@/pages/ResetPassword";
import ReclameAqui from "@/pages/ReclameAqui";
import ComplaintRespond from "@/pages/ComplaintRespond";
import AuthCallback from "@/pages/AuthCallback";
import Directory from "@/pages/Directory";
import JobOffers from "@/pages/JobOffers";
import ProfileDetail from "@/pages/ProfileDetail";
import Rentals from "@/pages/Rentals";
import RentalDetail from "@/pages/RentalDetail";
import Propagandas from "@/pages/Propagandas";
import FaleConosco from "@/pages/FaleConosco";
import Privacidade from "@/pages/Privacidade";
import Termos from "@/pages/Termos";
import Dashboard from "@/pages/Dashboard";

function AppRouter() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash?.includes("session_id=")) return;
    api.post("/track/pageview", { path: location.pathname }).catch(() => {});
  }, [location.pathname, location.hash]);
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Auth />} />
      <Route path="/redefinir-senha" element={<ResetPassword />} />
      <Route path="/diretorio" element={<Directory />} />
      <Route path="/ofertas-trabalho" element={<JobOffers />} />
      <Route path="/profissional/:id" element={<ProfileDetail />} />
      <Route path="/alugueis" element={<Rentals />} />
      <Route path="/alugueis/:id" element={<RentalDetail />} />
      <Route path="/propagandas" element={<Propagandas />} />
      <Route path="/reclame-aqui" element={<ReclameAqui />} />
      <Route path="/reclamacao/responder" element={<ComplaintRespond />} />
      <Route path="/contato" element={<FaleConosco />} />
      <Route path="/privacidade" element={<Privacidade />} />
      <Route path="/termos" element={<Termos />} />
      <Route path="/dashboard" element={<Dashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
